module.exports = __webpack_public_path__ + "static/media/14.d087ff99.jpg";